import * as Sentry from '@sentry/node'
import Message from '@components/Message'

const getMessage = statusCode => `${statusCode || 'Unknown'} | Failed to load`

const Error = ({ statusCode }) => <Message>{getMessage(statusCode)}</Message>

Error.getInitialProps = ({ req, res, err }) => {
    const errorCode = err ? err.statusCode : 404
    const statusCode = res ? res.statusCode : errorCode
    if (req?.path) {
        Sentry.captureMessage(`${getMessage(statusCode)} | ${req.path}`)
    } else {
        Sentry.captureException(err)
    }
    return { statusCode }
}

export default Error
